"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKVStoreService = void 0;
const config_1 = require("./../../config");
const axiosInterceptors_1 = require("../../utils/axiosInterceptors");
const restify_1 = require("../../utils/restify");
function createKVStoreService({ env, baseUrl: overrideBaseUrl }) {
    const interceptors = {
        request: [axiosInterceptors_1.authRequestInterceptor],
        response: [axiosInterceptors_1.unauthorizedResponseInterceptor],
    };
    const baseURL = overrideBaseUrl || config_1.config.kvStore[env];
    const base = restify_1.restify(baseURL, interceptors);
    const kvStoreV2Base = base.one('v2');
    return {
        v2: {
            base: kvStoreV2Base,
            channels: kvStoreV2Base.one('channel'),
        },
    };
}
exports.createKVStoreService = createKVStoreService;
